export const FETCH_SITE_STATUS_REQUEST = 'FETCH_SITE_STATUS_REQUEST';
export const FETCH_SITE_STATUS_SUCCESS = 'FETCH_SITE_STATUS_SUCCESS';
export const FETCH_SITE_STATUS_FAILURE = 'FETCH_SITE_STATUS_FAILURE';

// Filtered Data 

export const FETCH_FILTERED_DATA_REQUEST = 'FETCH_FILTERED_DATA_REQUEST';
export const FETCH_FILTERED_DATA_SUCCESS = 'FETCH_FILTERED_DATA_SUCCESS';
export const FETCH_FILTERED_DATA_FAILURE = 'FETCH_FILTERED_DATA_FAILURE';